<ion-list mode="ios" lines="none" class="list-content reward-modal-list">
  <!-- Close Button Header -->
  <ion-item mode="md" color="transparent" lines="none">
    <ion-buttons slot="end">
      <ion-button
        shape="round"
        mode="ios"
        class="button-close"
        (click)="onClose()"
      >
        <app-icon-getm
          [name]="'close'"
          [size]="'xs'"
          [color]="'var(--color-gray-80)'"
        ></app-icon-getm>
      </ion-button>
    </ion-buttons>
  </ion-item>

  <!-- Reward Icon Section -->
  <ion-item mode="md" color="transparent" lines="none">
    <ion-img
      class="img-logo"
      [src]="'Miscellaneous.program-logo.' + (Programa | async) | translate"
    ></ion-img>
  </ion-item>

  <!-- Content Section -->
  <ion-item mode="md" color="transparent" lines="none" class="ion-text-center">
    <ion-label mode="md" class="reward-modal-title">
      {{ 'Modals.reward-promo.title' | translate }}

      <p class="reward-modal-subtitle">
        {{ 'Modals.reward-promo.subtitle' | translate }}
      </p>
    </ion-label>
  </ion-item>

  <hr class="separator-gray" />

  <ion-item mode="md" color="transparent" lines="none" class="ion-text-center">
    <ion-label mode="md" class="reward-modal-description">
      {{ 'Modals.reward-promo.description' | translate }}
    </ion-label>
  </ion-item>

  <!-- Close Button Footer -->
  <ion-item mode="md" color="transparent" lines="none">
    <app-button-getm
      type="white"
      size="medium"
      [expand]="true"
      [fill]="'outline'"
      (buttonClick)="onClose()"
    >
      {{ 'Modals.reward-promo.closeButton' | translate }}
    </app-button-getm>
  </ion-item>
</ion-list>
